"use client";

import { Badge } from "@/components/ui/badge";
import type { StageItem } from "./types";

export function LockedStageCard({
  stage,
  displayIndex,
}: {
  stage: StageItem;
  displayIndex: number;
}) {
  return (
    <div className="bg-surface-header border border-border rounded-lg overflow-hidden p-4 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] z-[1] w-full">
      <div className="flex flex-col gap-2.5">
        <div className="flex h-7 items-center">
          <div className="flex gap-2 items-center">
            <div className="bg-contrast/4 flex items-center justify-center w-7 py-1 px-2 rounded-full shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
              <span className="text-sm font-medium text-heading">
                {displayIndex}
              </span>
            </div>
            <Badge
              variant="linear"
              size="lg"
              style={{ "--gradient-color": stage.color } as React.CSSProperties}
            >
              {stage.name}
            </Badge>
          </div>
        </div>
        {stage.description && (
          <p className="text-[13px] text-contrast/70 leading-normal">
            {stage.description}
          </p>
        )}
      </div>
    </div>
  );
}
